import React, {FC} from 'react'

import cn from 'classnames/bind'

import s from './HeadingSection.module.scss'
const cx = cn.bind(s)

interface IHeadingSectionProps {
	children: string
	className?: string
}

const HeadingSection: FC<IHeadingSectionProps> = ({children, className}) => {
	return <h2 className={cx('heading', className)}>{children}</h2>
}

HeadingSection.displayName = 'HeadingSection'

export default HeadingSection
